import {ViewType} from "../../../gd/const/views/view-type"
import {NavigationSectionType} from "../../navigation/@const"
import {MY_WORK_VIEWS, PROJECTS_VIEWS} from "../../../gd/const/views/view-type-config";

export default function getCustomViewDefaultLocation(type:ViewType) {

    if (type === ViewType.MY_GOALS) {
        return NavigationSectionType.NAVIGATION_PANEL
    }

    if (type === ViewType.MY_ATTENDANCE) {
        return NavigationSectionType.NAVIGATION_PANEL
    }

    if (MY_WORK_VIEWS.includes(type)) {
        return NavigationSectionType.HOME
    }

    if (PROJECTS_VIEWS.includes(type)) {
        return NavigationSectionType.PROJECTS
    }

    return NavigationSectionType.TOOLS
}
